import React, { createContext, useState, useEffect, useCallback  } from "react";
import { normalizeLang } from "../layouts/language/langUtil";

export const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const getInitialLanguage = () => {
    if (typeof window !== "undefined") {
      const params = new URLSearchParams(window.location.search);
      // 官網導流帶 ?lang=（短碼 tw/cn/en/uk 或 canonical 皆可）→ 正規化後採用並寫入 localStorage
      const fromUrl = normalizeLang(params.get("lang"));
      if (fromUrl) {
        localStorage.setItem("language", fromUrl);
        return fromUrl;
      }
    }
    // localStorage 既有值也正規化（吸收舊 "en" 等），無有效值則預設繁中
    return normalizeLang(localStorage.getItem("language")) || "zh-TW";
  };

  const [language, setLanguage] = useState(getInitialLanguage());
  const [componentLanguageData, setComponentLanguageData] = useState({});

  const changeLanguage = useCallback((newLang) => {
    if (typeof localStorage !== "undefined") {
      try {
        localStorage.setItem("language", newLang);
      } catch (err) {
        console.warn("⚠️ 無法寫入 localStorage（可能是無痕或隱私模式）：", err);
      }
    } else {
      console.warn("⚠️ localStorage 不可用，略過儲存語言設定");
    }

    setLanguage(newLang); // 無論儲存成功與否，仍更新前端狀態
  }, []);

  const loadLanguageFile = useCallback(async (componentKey, langFilePath) => {
    try {
      const langModule = await import(`../layouts/language/${langFilePath}.js`);
      setComponentLanguageData((prevData) => ({
        ...prevData,
        [componentKey]: langModule.Init(language) || { Main: {} }
      }));
    } catch (error) {
      console.error(`❌ 無法載入語言檔案: ${langFilePath}`, error);
      setComponentLanguageData((prevData) => ({
        ...prevData,
        [componentKey]: { Main: {} }
      }));
    }
  }, [language]);

   // ✅ 當語言變更時，更新 <body> 的 data-lang 屬性
   useEffect(() => {
    document.body.setAttribute("data-lang", language);
  }, [language]);

  

  return (
    <LanguageContext.Provider value={{ language, componentLanguageData, changeLanguage, loadLanguageFile }}>
      {children}
    </LanguageContext.Provider>
  );
};
